import React, { useContext } from "react";
import { QuestionContext } from "../../context";
import { Radio } from "antd";
import classNames from "classnames";
import "./index.scss";

export function OptionsJudge({ className, style }: RenderComponent) {
    const ctx = useContext(QuestionContext);
    if (ctx.type !== "Judge") throw new Error("error type data");

    return (
        <Radio.Group
            value={ctx.data.answer}
            className={classNames("QuestionOptionsJudge", className)}
            style={style}>
            <Radio value>A. 正确</Radio>
            <Radio value={false}>B. 错误</Radio>
        </Radio.Group>
    );
}
